import assign from 'object-assign';
import { EventEmitter } from 'events';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';
const ActionTypes = AdminConstants.ActionTypes;
var frequentShippers = [];
var growthMetrics = {};
var dailyMetrics = {};
var ReportingStore = assign({}, EventEmitter.prototype, {
    receiveFrequentShippers: function (data) {
        frequentShippers = data.frequentShippers;
    },
    receiveGrowthMetrics: function (data) {
        growthMetrics[data.market] = data.metrics;
    },
    receiveDailyGrowthMetrics: function (data) {
        dailyMetrics.growth = data.metrics;
    },
    receiveDailyCustomerMetrics: function (data) {
        Object.assign(dailyMetrics, data.metrics);
    },
    receiveDailyLookbackMetrics: function (data) {
        Object.assign(dailyMetrics, data.metrics);
    },
    getFrequentShippers: function () {
        return frequentShippers;
    },
    getMarketGrowthMetrics: function (market) {
        return growthMetrics[market] || [];
    },
    getDailyReportMetrics: function () {
        return dailyMetrics || {};
    },
    emitChange: function () {
        this.emit('change');
    },
    addChangeListener: function (callback) {
        this.on('change', callback);
    },
    removeChangeListener: function (callback) {
        this.removeListener('change', callback);
    }
});
ReportingStore.dispatchToken = AdminAppDispatcher.register(function (payload) {
    var action = payload.action;
    switch (action.type) {
        case ActionTypes.RECEIVE_FREQUENT_SHIPPERS:
            ReportingStore.receiveFrequentShippers(action.data);
            ReportingStore.emitChange();
            break;
        case ActionTypes.RECEIVE_GROWTH_METRICS:
            ReportingStore.receiveGrowthMetrics(action.data);
            ReportingStore.emitChange();
            break;
        case ActionTypes.RECEIVE_DAILY_GROWTH_METRICS:
            ReportingStore.receiveDailyGrowthMetrics(action.data);
            ReportingStore.emitChange();
            break;
        case ActionTypes.RECEIVE_DAILY_CUSTOMER_METRICS:
            ReportingStore.receiveDailyCustomerMetrics(action.data);
            ReportingStore.emitChange();
            break;
        case ActionTypes.RECEIVE_DAILY_LOOKBACK_METRICS:
            ReportingStore.receiveDailyLookbackMetrics(action.data);
            ReportingStore.emitChange();
            break;
    }
});
export default ReportingStore;
